import React from 'react';
import styled from 'styled-components';
import {useTranslations} from "use-intl";

import { useModal } from '@tager/web-components';

import FabricButton from '@/components/Button/FabricButton';
import InProgressForm from '@/components/Forms/InProgressForm';

function Material() {
  const t = useTranslations();
  const openModal = useModal();

  const handler = () => {
    openModal(
      InProgressForm,
      {
        title: t('material_unavailable'),
      },
      {
        withAnimation: false,
        scrollLockDisabled: true,
      }
    );
  };
  return (
    <Component>
      <FabricStyledIcon onClick={handler}>
        {t('material_select')}
      </FabricStyledIcon>
    </Component>
  );
}

export default Material;

const Component = styled.div``;
const FabricStyledIcon = styled(FabricButton)`
  max-width: 480px;
`;
